import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzerverwaltung-benutzer-zugriff';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerverwaltungBenutzerZugriffEffects {

    BenutzerverwaltungBenutzerZugriff$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZERVERWALTUNG_BENUTZER_ZUGRIFF),
        mergeMap((x: ac.GetBenutzerverwaltungBenutzerZugriffAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerverwaltungBenutzerZugriff().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerverwaltungBenutzerZugriffErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerverwaltungBenutzerZugriffFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungQueryService);
        }
        return this.service;
    }
}
